var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonsterHandsUp3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 147,
    viewBox: "0 0 173 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14011_164661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.501 18.4528C148.689 7.71545 157.659 1.44818 164.54 4.45347C171.421 7.45875 173.607 18.5982 169.421 29.3363C165.231 40.0728 133.339 105.138 126.46 102.134C119.579 99.1259 140.318 29.1889 144.501 18.4528Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4988 15.4528C23.311 4.71545 14.3411 -1.55182 7.46002 1.45347C0.578933 4.45875 -1.60691 15.5982 2.57926 26.3363C6.76875 37.0728 38.6609 102.138 45.5403 99.1338C52.4204 96.1259 31.6823 26.1889 27.4988 15.4528Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M147.657 21.0608C150.736 13.1694 157.33 8.56007 162.39 10.7668C167.446 12.978 169.051 21.1676 165.974 29.0598C162.897 36.9546 139.454 84.7757 134.398 82.5678C129.339 80.3584 144.581 28.953 147.657 21.0608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.3421 18.0608C21.2638 10.1694 14.6699 5.56007 9.60974 7.76681C4.55328 9.97801 2.94872 18.1676 6.02531 26.0598C9.10292 33.9546 32.546 81.7757 37.6018 79.5678C42.6609 77.3584 27.4187 25.953 24.3421 18.0608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7177 38.3037C32.4383 37.6933 30.6414 37.9861 29.8451 39.3299C28.2116 42.0864 31.4159 48.2265 37.0004 53.0461C37.3473 53.3453 37.6953 53.6323 38.0432 53.9069C31.8221 54.2722 26.9887 56.8962 27.0001 60.0563C27.0098 63.0319 31.3136 65.4922 37.0149 66.0237C34.5606 70.6967 32.7918 76.3227 31.7114 83.0592C37.8499 93.1494 43.1742 100.167 45.5402 99.1339C50.3163 97.0458 41.7829 62.7038 34.7177 38.3037Z",
    fill: "#B21F5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.641 85.4768C134.355 95.8778 128.871 103.187 126.46 102.134C121.47 99.9525 131.005 62.574 138.218 38.0998C140.05 37.7971 141.471 38.1761 142.155 39.3306C143.789 42.0863 140.585 48.2263 135 53.0458C134.653 53.3451 134.305 53.6322 133.957 53.9068C140.179 54.272 145.012 56.8959 145.001 60.056C144.991 63.0315 140.687 65.4918 134.986 66.0236C137.729 71.2449 139.615 77.6561 140.641 85.4768Z",
    fill: "#B21F5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.333 53.5237C126.148 57.2145 120.716 58.4932 119.198 56.38C117.684 54.265 120.658 49.5601 125.843 45.8686C131.028 42.1761 136.46 40.8965 137.976 43.011C139.494 45.1232 136.518 49.8295 131.333 53.5237Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.058 63.5517C122.682 63.5269 117.523 61.4024 117.533 58.8053C117.543 56.2094 122.72 54.125 129.095 54.1498C135.47 54.1746 140.63 56.2992 140.618 58.8962C140.608 61.4921 135.433 63.5765 129.058 63.5517Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.587 44.769C113.545 50.7884 113.884 56.3415 116.351 57.1712C118.817 57.9983 122.471 53.7904 124.516 47.7718C126.557 41.7509 126.219 36.1978 123.751 35.3692C121.285 34.541 117.629 38.7481 115.587 44.769Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3395 53.5232C45.5232 57.2134 50.9562 58.4927 52.4739 56.3805C53.9884 54.2646 51.015 49.5597 45.8293 45.8681C40.6434 42.175 35.2131 40.896 33.6957 43.0099C32.1789 45.1228 35.1543 49.8291 40.3395 53.5232Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6142 63.5517C48.9902 63.5268 54.1502 61.4022 54.1388 58.8051C54.1286 56.2092 48.9533 54.1249 42.5773 54.1498C36.2024 54.1746 31.0424 56.2993 31.0538 58.8963C31.064 61.4922 36.2393 63.5765 42.6142 63.5517Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0824 44.7683C58.1242 50.7891 57.7855 56.3411 55.3195 57.1705C52.8532 57.9989 49.1978 53.7904 47.1552 47.7711C45.1133 41.7503 45.4521 36.1983 47.9184 35.37C50.3844 34.5405 54.0394 38.7479 56.0824 44.7683Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.424 90.2905C137.424 56.1402 120.109 47.5303 85.8357 47.5303C51.5656 47.5303 34.2489 56.1402 34.2489 90.2905C34.2489 114.836 49.2167 146.085 62.9314 146.236C73.91 146.356 72.9845 138.036 85.8357 138.055C98.52 138.076 97.0454 147.077 107.057 146.999C124.424 146.864 137.424 117.014 137.424 90.2905Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M136.008 60.2909C136.015 58.1912 132.12 56.4476 127.108 56.2043C127.39 56.0215 127.674 55.828 127.955 55.6286C132.454 52.4275 135.034 48.3457 133.72 46.513C132.407 44.6816 127.695 45.7938 123.197 48.9961C122.916 49.1967 122.644 49.4008 122.378 49.6074C123.77 44.8039 123.377 40.5666 121.379 39.8948C119.237 39.1731 116.07 42.8205 114.298 48.0382C112.53 53.2572 112.831 58.0713 114.97 58.7918C115.703 59.0387 116.557 58.774 117.431 58.1093L117.435 58.1129C116.537 58.7135 116.016 59.4173 115.993 60.171C108.763 57.0743 98.7637 56.4001 85.8363 56.4001C73.2901 56.4001 63.5014 57.0351 56.3272 59.9039C56.2033 59.2523 55.7031 58.6422 54.9133 58.1141C54.9133 58.1141 54.9157 58.1129 54.9157 58.1117C54.9157 58.1117 54.9181 58.1105 54.9181 58.1093C55.7924 58.774 56.6464 59.0387 57.379 58.7918C59.5206 58.0713 59.8196 53.2572 58.0508 48.0382C56.2808 42.8205 53.1123 39.1731 50.9707 39.8948C48.9743 40.5666 48.5801 44.8039 49.9713 49.6074C49.7069 49.4008 49.4329 49.1967 49.1518 48.9961C44.6541 45.7938 39.9444 44.6816 38.6294 46.513C37.3167 48.3457 39.8979 52.4275 44.3944 55.6286C44.6756 55.828 44.959 56.0215 45.2401 56.2043C40.2279 56.4476 36.334 58.1912 36.3412 60.2909C36.3495 62.5425 40.8389 64.3502 46.3681 64.3288C47.4187 64.3241 48.4312 64.2552 49.3841 64.1282C43.8549 69.1418 41.1724 77.3007 41.1724 90.4768C41.1724 120.818 55.3898 137.523 85.8363 137.523C116.283 137.523 130.5 120.818 130.5 90.4768C130.5 77.1915 127.774 69.0065 122.153 64.0024C123.332 64.2077 124.624 64.3217 125.983 64.3288C131.51 64.3502 135.998 62.5425 136.008 60.2909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 85.8248,
    cy: 91.2937,
    rx: 48.025,
    ry: 44.8337,
    fill: "url(#paint0_radial_14011_164661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8249 94.2727C70.8226 94.2727 59.0244 84.5862 53.7786 76.0676C56.4504 84.5719 68.9644 97.7171 85.8249 97.7171C102.554 97.7171 115.248 84.4746 117.893 75.9727C112.623 84.515 100.712 94.2727 85.8249 94.2727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8249 93.8184C70.8226 93.8184 59.0244 84.133 53.7786 75.6133C56.4504 84.1188 68.9644 97.2652 85.8249 97.2652C102.554 97.2652 115.248 84.0203 117.893 75.5195C112.623 84.0618 100.712 93.8184 85.8249 93.8184Z",
    fill: "#6D0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.601 49.8668C118.601 67.4654 103.933 81.7334 85.8349 81.7334C67.7404 81.7334 53.0692 67.4654 53.0692 49.8668C53.0692 32.2683 67.7404 18.0002 85.8349 18.0002C103.933 18.0002 118.601 32.2683 118.601 49.8668Z",
    fill: "#DB1375"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.766 49.4111C113.766 64.7818 101.261 77.2422 85.8359 77.2422C70.4108 77.2422 57.9062 64.7818 57.9062 49.4111C57.9062 34.0405 70.4108 21.5801 85.8359 21.5801C101.261 21.5801 113.766 34.0405 113.766 49.4111Z",
    fill: "url(#paint1_radial_14011_164661)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.652 49.4093C105.652 60.3133 96.7813 69.1527 85.8387 69.1527C74.8961 69.1527 66.0254 60.3133 66.0254 49.4093C66.0254 38.5054 74.8961 29.666 85.8387 29.666C96.7813 29.666 105.652 38.5054 105.652 49.4093Z",
    fill: "url(#paint2_radial_14011_164661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1035 49.41C95.1035 54.5114 90.9548 58.6455 85.8353 58.6455C80.7158 58.6455 76.5671 54.5114 76.5671 49.41C76.5671 44.3098 80.7158 40.1746 85.8353 40.1746C90.9548 40.1746 95.1035 44.3098 95.1035 49.41Z",
    fill: "#49482A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.83,
    cy: 39.6843,
    rx: 11.03,
    ry: 8.47434,
    fill: "url(#paint3_radial_14011_164661)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.767 119.148C113.767 127.014 101.262 133.392 85.8369 133.392C70.4141 133.392 57.9072 127.014 57.9072 119.148C57.9072 111.285 70.4141 104.908 85.8369 104.908C101.262 104.908 113.767 111.285 113.767 119.148Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14011_164661",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.8248 86.751) rotate(90) scale(49.2892 63.4666)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224916,
    stopColor: "#E4E4E4",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521135,
    stopColor: "#C57730",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14011_164661",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.8362 49.4108) scale(27.9297 27.831)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_14011_164661",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.8383 49.4097) scale(19.8133 19.7433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9757EE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_14011_164661",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.83 57.5268) rotate(-90) scale(26.3168 34.2534)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#2E2A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#2E2A49",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#B0C5FB",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14011_164661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 173,
    height: 147,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonsterHandsUp3);
export default __webpack_public_path__ + "static/media/MonsterHandsUp3.8d8f0da9c792320c73289db1f4ae1b80.svg";
export { ForwardRef as ReactComponent };